<template>
  <div class="GlobalTable">
    <GlobalTable ref="GlobalTable" v-loading="loading" :columns="tableColumns" :data="seachDataList"
      :currentPage="page.pageNum" :total="page.total" @handleCurrentChange="handleCurrentChange">
      <el-table-column label="添加人" slot="accName" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.createManagerAcc">{{ row.createManager }} - {{ row.createManagerAcc }}</span>
          <span v-else>系统自动同步</span>
        </template>
      </el-table-column>
      <el-table-column label="添加方式" slot="addType" align="center">
        <template slot-scope="{ row }">
          <div>{{row.createType=='00'?'已有店员同步':'自主添加'}}</div>
          <div v-if="row.createType=='00'" class="add-btn" @click="seeStaff(row)">查看</div>
        </template>
      </el-table-column>
      <el-table-column width="200" label="操作" slot="operation" align="center">
        <template slot-scope="{ row }">
          <div class="add-btn" style="color: #ff687b;" @click="removeBlack(row)">从黑名单移除</div>
        </template>
      </el-table-column>
    </GlobalTable>
    <el-dialog title="操作提示" :visible.sync="removeShow" :close-on-click-modal="false" width="500px">
      <div class="code-tip">
        <div>说明：移除后该人员将不再进行收款限制</div>
        <div class="tip-sure">是否确认将该人员从黑名单移除？</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="removeShow = false">取消</el-button>
        <el-button type="primary" :loading="removeLoading" @click.native="removeSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
export default {
  name: "Table",
  data() {
    return {
      loading: false,
      tableColumns: [
        { label: "黑名单人员姓名", prop: "staffName" },
        { label: "黑名单人员手机号", prop: "mobile" },
        { label: "限制收款门店", prop: "storeName" },
        { slotName: "accName" },
        { slotName: "addType" },
        { label: "添加时间", prop: "createTime" },
        { slotName: "operation" },
      ],
      seachDataList: [],
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      removeShow: false,
      removeLoading: false,
      removeRow: {}
    };
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    },
    storeAddEdit() {
      return this.$store.state.tagsView.storeAddEdit;
    },
    storeExcel() {
      return this.$store.state.tagsView.storeExcel;
    },
  },
  created() {
    this.handleCurrentChange();
  },
  watch: {
    SeachParams(newVal) {
      console.log(newVal);
      this.handleCurrentChange();
    },
  },
  methods: {
    // 表格切换页面
    handleCurrentChange(val) {
      if(val){
        this.page.pageNum = val;
      }
      const baseRequest = {
        storeId: this.SeachParams.storeId || "",
        staffName: this.SeachParams.staffName || "",
        mobile: this.SeachParams.mobile || "",
        createType: this.SeachParams.createType || "",
        startTime: this.SeachParams.startTime,
        endTime: this.SeachParams.endTime,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      this.loading = true
      _api.getBlackStaffList(baseRequest).then((res) => {
        if (res.code === 1) {
          console.log(res);
          this.seachDataList = res.data.records;
          this.page.total = res.data.total;
          this.page.pageNum = res.data.current;
        }
      })
      .finally(() => {
        this.loading = false
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      });
    },
    removeBlack(row) {
      this.removeRow = row
      this.removeShow = true
    },
    removeSubmit() {
      this.removeLoading = true
      _api.removeBlackId({id:this.removeRow.id}).then(res => {
        if(res.code === 1){
          this.$message.success('操作成功')
          this.removeShow = false
          if(this.seachDataList.length === 1 && this.page.pageNum > 1){
            this.handleCurrentChange(this.page.pageNum - 1)
          }else {
            this.handleCurrentChange()
          }
        }
      }).finally(() => {
        this.removeLoading = false
      });
    },
    seeStaff(row) {
      this.$router.push({ path: "/systemManage/StaffManage",query: {type: 'xcx', storeId: row.storeId,mobile: row.mobile } })
    }
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.add-btn{
  color: #0981FF;
  text-decoration: underline;
  cursor: pointer;
}
.tip{
  font-size: 14px;
  color: #ff687b;
  margin-left: 10px;
}
.code-tip {
  color: #ff8080;
  font-size: 14px;
  margin-bottom: 20px;

  .tip-sure {
    margin-top: 10px;
    color: #333333;
    font-size: 16px;
    text-align: center;
  }
}
</style>
